module.exports = __webpack_public_path__ + "static/GH1-d562edf40a51401213e434259c82fcab.png";